<template>
  <div class="container pt-3">
    <mainloader v-if="pageLoading" />
    <div v-if="!pageLoading && GET_USER">
      <div class="row justify-content-center">
        <div class="col-12 col-sm-6 pt-5 pb-5">
          <div class="card">
            <div class="card-body">
              <h5 class="card-title">{{ $t('nafath.wellcome') }} {{ GET_USER_DATA.userName }}</h5>
              <p class="card-text">{{ $t('register.already_login') }}</p>
              <router-link to="/" class="card-link">{{ $t('nav.home') }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!pageLoading && !GET_USER">
      <div v-if="affiliate">
        <div class="row justify-content-center">
          <div class="col-12 col-sm-6 pt-5 pb-5">
            <div class="card">
              <div class="card-body">
                <h5 class="card-title">{{ $t('nafath.wellcome') }}</h5>
                <p class="card-text">
                  <span class="alert alert-info">{{ $t('register.installText') }}</span>
                </p>
                <div class="row">
                  <div class="col-6 text-center">
                    <a href="https://play.google.com/store/apps/details?id=com.almuhaysini.amaqaria">
                      <img src="/assets/images/Google-Play-2.png" class="btn-App" alt="" />
                    </a>
                  </div>
                  <div class="col-6 text-center">
                    <a href="https://apps.apple.com/app/%D8%B9%D9%82%D8%A7%D8%B1-%D8%A7%D9%84%D9%85%D8%AD%D9%8A%D8%B3%D9%86%D9%8A/id6757802216">
                      <img src="/assets/images/App-Store-2.png" class="btn-App" alt="" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!affiliate">
        <div class="row justify-content-center register" v-if="step == 1">
          <div class="col-12 col-md-6">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <div class="card registration">
              <div class="card-body">
                <h4 class="almarai-bold">{{$t('register.title_1')}}</h4>
                <form action="">
                  <div class="row">
                    <div class="col">
                      <label class="text-style p-2">
                        {{$t('register.title_2')}}
                        <span class="stars">*</span>
                      </label>
                      <input type="text" v-model="fullName" id="name" maxlength="50"
                        @keypress="charsOnly"
                        class="form-control phone-input" :placeholder="$t('register.title_13')" 
                      >
                    </div>
                    <div class="error-feedback red-color fonttext-14" v-if="V$.fullName.$error">
                      {{ validateMessage }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col position-R">
                      <label class="text-style p-2">
                        {{$t('register.title_3')}}
                        <span class="stars">*</span>
                      </label>
                      <span class="phone-icon"><i class="fa-solid fa-phone"></i></span>
                      <input type="text" v-model="mobile" @change="registrationAttempts"  id="phone" maxlength="10" @input="mobile = mobile.replace(/[^0-9]/g, '')"
                        class="form-control phone-input"  :placeholder="$t('register.title_14')" 
                      >
                    </div>
                    <div class="error-feedback red-color fonttext-14" v-if="V$.mobile.$error">
                      {{ validateMessage }}
                    </div>
                  </div>
                  <!-- <div class="row">
                    <div class="col position-R">
                      <label class="text-style p-2">
                        {{$t('register.title_4')}}
                        <span class="stars">*</span>
                      </label>
                      <input type="text" v-model="identity" maxlength="10" @input="identity = identity.replace(/[^0-9]/g, '')"
                        class="form-control phone-input" :placeholder="$t('register.title_15')" 
                      >
                    </div>
                    <div class="error-feedback red-color fonttext-14" v-if="V$.identity.$error">
                      {{ validateMessage }}
                    </div>
                  </div> -->
                  <div class="row">
                    <div class="col position-R">
                      <label class="text-style p-2">
                        {{$t('register.title_5')}}
                        <span class="stars">*</span>
                      </label>
                      <input :type="fieldType" placeholder="**********"  maxlength="50"
                        class="form-control phone-input" v-model="password" 
                      >
                      <span v-if="fieldType == 'password'" @click.prevent="togglePassword" class="eyes-Icons">
                        <i class="fa-regular fa-eye-slash"></i>
                      </span>
                      <span v-else  @click.prevent="togglePassword" class="eyes-Icons">
                        <i class="fa-regular fa-eye"></i>
                      </span>
                    </div>
                    <div class="error-feedback red-color fonttext-14" v-if="V$.password.$error">
                      {{ validateMessage }}
                    </div>
                  </div>
                  <div class="row pt-2">
                    <div class="col">
                      <label class="text-style p-2">
                        {{$t('invitationCode')}}
                      </label>
                      <input type="text" v-model="invitationCode" id="name" maxlength="50"
                        @keypress="charsOnly"
                        class="form-control phone-input" :placeholder="$t('enter_InvitationCode')" 
                      >
                    </div>
                  </div>
                  <div class="row pt-2">
                    <div class="col-12 content-end">
                      <div class="form-check check-style">
                        <label class="form-check-label show" for="checkDefault">
                          <input v-model="privacy_Policy" class="checkBox form-check-input radio" type="checkbox" id="checkDefault">
                          <span class="me-4 privacy_Policy">{{$t('privacy_Policy')}}</span>
                        </label>
                      </div>
                    </div>
                    <div class="error-feedback red-color fonttext-14" v-if="V$.privacy_Policy.$error">
                      {{ validateMessage }}
                    </div>
                  </div>
                  <div class="row pt-5 justify-content-center">
                    <div class="col-11 col-md-6 text-center mouse-hand">
                      <div class="text-center" v-if="loading">
                        <loader />
                      </div>
                      <div v-else @click.prevent="registerFN" class="form-control btn-green">{{$t('register.title_6')}}</div>
                    </div>
                  </div>
                  <div class="row pt-3">
                    <div class="col text-center">
                      <span class="textAccount">ــــــــــــ {{$t('register.title_7')}} ـــــــــــــ</span>
                    </div>
                  </div>
                  <div class="row pt-3 justify-content-center">
                    <div class="col-11 col-md-6 text-center">
                      <router-link to="/login">
                        <div class="form-control padding-style almarai-bold">
                          {{$t('register.title_8')}}
                        </div>
                      </router-link>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div class="col-12 col-md-6 d-none d-md-block">
            <img src="/assets/images/hero.png" class="max-600" alt="">
          </div>
        </div>
    
        <!-- <div class="row pt-5 random" v-if="step == 2">
          <div class="col text-center">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <div class="row justify-content-center py-3">
              <div class="col text-center">
                <span class="number almarai-bold">{{row.random}}</span>
              </div>
            </div>
            <div class="row justify-content-center pb-5 pt-3">
              <div class="col text-center">
                <div class="text-center" v-if="formLoading">
                  <loader />
                </div>
                <button v-else @click.prevent="checkNafath" class="padding-style buttonStyle almarai-bold">{{$t('register.title_9')}}</button>
              </div>
            </div>
          </div>
        </div> -->
    
        <div class="row justify-content-center" v-if="step == 2">
          <div class="col-12 col-md-7 ms-4">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <div class="card card-style">
              <div class="card-body">
                <div class="card-title text-center almarai-bold font-20">{{$t('register.title_10')}} OTP</div>
                <form action="">
                  <div class="row">
                    <div class="col">
                      <span class="text-style p-2">{{$t('register.title_11')}} OTP {{$t('register.title_12')}}</span>
                      <input type="text" v-model="code" class="form-control input-style my-2" maxlength="4">
                    </div>
                  </div>
                  <div class="row pt-3 justify-content-center">
                    <div class="col-12 col-md-6 btn-black">
                      <div @click.prevent="verifyMobile">{{$t('register.title_8')}}</div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { mapGetters } from 'vuex';
export default {
  name: 'register',

  setup () {
    return { V$: useVuelidate() }
  },

  data(){
    return {
      affiliate: this.$route.query.f ?? null,
      pageLoading: true,
      hasError: false,
      message: "",
      errorNumber: 0,
      fullName: "",
      identity: null,
      mobile: "",
      password: "",
      step: 1,
      code: "",
      row: {},
      loading: false,
      formLoading: false,
      verifyLoader: false,
      fieldType: 'password',
      validateMessage: this.$t('validateMessage'),
      invitationCode: "",
      privacy_Policy: null,
    }
  },
  computed: {
    ...mapGetters(['ISLOADING','GET_USER', 'GET_USER_DATA'])
  },
  validations(){
    return {
      fullName: {required},
      mobile: {required},
      password: {required},
      privacy_Policy: {required},
    }
  },

  methods:{
    async registerFN(){
      this.hasError = false;
      const valid = await this.V$.$validate();
      if(!valid){
        window.scrollTo({top:0, behavior:'smooth'});
        return false;
      }

      let payload = {
        name: this.fullName,
        mobile: this.mobile,
        password: this.password,
        affiliate: this.invitationCode,
      }
      if(this.affiliate)
        payload.affiliate = this.affiliate;
      if(!this.mobile.startsWith('05') || this.mobile.trim().length != 10){
        this.message = this.$t('incorrectMobile');
        this.hasError = true;
        window.scrollTo({top:0, behavior:'smooth'});
        return false;
      }

      this.loading = true,
      this.$http.post("/api/auth/register", payload).then(res => {
        // console.log(res);
        this.row = res.data;
        this.step = 2;
        this.loading = false;
      }).catch(err => {
        // console.log(err);
        this.loading = false;
        [this.message , this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scroll(0,0);
        
      });
    },

    registrationAttempts(){
      if(this.mobile.trim().length == 10){
        this.$http.post('/api/registrationAttempts/create',{
          mobile: this.mobile,
          name: this.fullName,
          source: 'website',
        }).then(res => {

        }).catch(err => {
          this.loading = false;
          [this.message , this.errorNumber] = this.$globalError(err, true);
          this.hasError = true;
          window.scroll(0,0);
        })
      }
    },

    checkNafath(){
      this.hasError = false;
      this.formLoading = true;
      this.$http.post("/api/auth/register/checkStatus",{
        identity: this.identity,
      }).then(res => {
        // console.log(res);
        this.step = 3;
        this.formLoading = false;
      }).catch(err => {
        // console.log(err);
        this.formLoading = false;
        [this.message , this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scroll(0,0);
      });
    },

    verifyMobile(){
      this.hasError = false;
      this.verifyLoader = true;
      this.$http.post("/api/auth/register/verify",{
        mobile: this.mobile,
        code: this.code,
        platform: "website",
      }).then(res => {
        // console.log(res);
        this.$store.commit('SET_USER_DATA', res.data.user);
        window.location.href = '/';
        this.verifyLoader = false;
      }).catch(err => {
        // console.log(err);
        this.verifyLoader = false;
        [this.message , this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scroll(0,0);
      });
    },

    togglePassword(){
      this.fieldType = this.fieldType === 'password' ? 'text' : 'password';
    },

    charsOnly(e) {
      // keep only Arabic letters, Latin letters, and spaces
      // requires modern JS regex support for Unicode property escapes
      const char = e.key;
      const allowed = /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FFA-Za-z\s]$/;

      if (!allowed.test(char)) {
        e.preventDefault(); // block the input
      }
    },
    readUserData(){
      if(!this.ISLOADING){
        this.pageLoading = false;
      }else{
        setTimeout(() => {
          this.readUserData();
        }, 200);
      }
    },
  },
  created(){
    this.readUserData();
    if(this.affiliate){
      this.invitationCode = this.affiliate;
    }
    window.scroll(0,0);
  }
}
</script>
